import React from 'react';
import { assets } from '../mock';

function Corner({ pos }) {
  const base = { position: 'absolute', width: 28, height: 28, borderColor: 'rgba(34,224,107,0.7)', pointerEvents: 'none', zIndex: 3 };
  const map = {
    tl: { top: 16, left: 16, borderTop: '2px solid', borderLeft: '2px solid' },
    tr: { top: 16, right: 16, borderTop: '2px solid', borderRight: '2px solid' },
    bl: { bottom: 16, left: 16, borderBottom: '2px solid', borderLeft: '2px solid' },
    br: { bottom: 16, right: 16, borderBottom: '2px solid', borderRight: '2px solid' },
  };
  return <span style={{ ...base, ...map[pos] }} />;
}

export default function Banner() {
  return (
    <section style={{ padding: '10px 24px 36px' }}>
      <div style={{ position: 'relative', maxWidth: 1160, margin: '0 auto', borderRadius: 22, overflow: 'hidden', border: '1px solid rgba(34,224,107,0.24)', boxShadow: '0 30px 80px rgba(0,0,0,0.55)', background: '#04070a', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, minHeight: 420 }}>
        {/* Fond flouté pour combler les côtés (fini le grand rectangle vide) */}
        <video src={assets.bannerVideo} muted loop playsInline autoPlay preload="auto" aria-hidden="true"
          style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover', filter: 'blur(34px) brightness(0.55) saturate(1.1)', transform: 'scale(1.25)', zIndex: 0 }} />
        <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(700px 420px at 50% 45%, rgba(34,224,107,0.14), transparent 62%), linear-gradient(180deg, rgba(4,7,10,0.35), rgba(4,7,10,0.6))', zIndex: 1 }} />
        <Corner pos="tl" /><Corner pos="tr" /><Corner pos="bl" /><Corner pos="br" />
        <video
          src={assets.bannerVideo}
          muted
          loop
          playsInline
          autoPlay
          preload="auto"
          style={{ position: 'relative', zIndex: 2, maxWidth: '100%', maxHeight: 560, width: 'auto', height: 'auto', borderRadius: 14, display: 'block', boxShadow: '0 20px 50px rgba(0,0,0,0.6)' }}
        />
      </div>
    </section>
  );
}
